import React from 'react';
import { LandPlotIcon, Building2Icon, CarIcon, ArrowRightIcon } from 'lucide-react';
export function PropertyFundamentals() {
  return <section className="bg-[#1E3D2F] text-[#F5F0E8] py-20 px-6" data-id="element-55">
      <div className="max-w-7xl mx-auto" data-id="element-56">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-57">
          {/* Section Title */}
          <div className="lg:col-span-4" data-id="element-58">
            <h2 className="text-4xl md:text-5xl mb-6 leading-tight" data-id="element-59">
              Property <br data-id="element-60" />
              <span className="italic text-[#C9B99A]" data-id="element-61">Fundamentals</span>
            </h2>
            <div className="h-px w-full bg-[#C9B99A]/30 my-8" data-id="element-62" />
            <p className="text-lg font-light opacity-80 leading-relaxed" data-id="element-63">
              An exceptional corner landholding in one of Toorak's most
              prestigious enclaves, offering significant development potential
              or a grand family estate opportunity.
            </p>
          </div>

          {/* Stats Grid */}
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-64">
            {/* Stat 1 */}
            <div className="border border-[#C9B99A]/30 p-8 hover:bg-[#C9B99A]/5 transition-colors duration-300 group" data-id="element-65">
              <LandPlotIcon className="h-10 w-10 text-[#C9B99A] mb-6 stroke-[1.5]" data-id="element-66" />
              <div className="text-4xl font-medium mb-2" data-id="element-67">
                538<span className="text-xl align-top" data-id="element-68">SQM*</span>
              </div>
              <p className="text-sm tracking-widest uppercase opacity-70" data-id="element-69">
                Land Area
              </p>
            </div>

            {/* Stat 2 */}
            <div className="border border-[#C9B99A]/30 p-8 hover:bg-[#C9B99A]/5 transition-colors duration-300 group" data-id="element-70">
              <Building2Icon className="h-10 w-10 text-[#C9B99A] mb-6 stroke-[1.5]" data-id="element-71" />
              <div className="text-4xl font-medium mb-2" data-id="element-72">
                831<span className="text-xl align-top" data-id="element-73">SQM*</span>
              </div>
              <p className="text-sm tracking-widest uppercase opacity-70" data-id="element-74">
                Building Area
              </p>
            </div>

            {/* Stat 3 */}
            <div className="border border-[#C9B99A]/30 p-8 hover:bg-[#C9B99A]/5 transition-colors duration-300 group" data-id="element-75">
              <CarIcon className="h-10 w-10 text-[#C9B99A] mb-6 stroke-[1.5]" data-id="element-76" />
              <div className="text-4xl font-medium mb-2" data-id="element-77">Secure</div>
              <p className="text-sm tracking-widest uppercase opacity-70" data-id="element-78">
                Car Parks
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}